import { connect } from "react-redux";
import * as applicationActions from "./actions";
import { get_row_additional_data_bisnode } from "./actions";
import * as usersActions from "../users/actions";
import * as creditSettlementActions from "../creditSettlement/actions";

function mapStateToProps(state) {
  return {
    applications: state.applications.applications,
    kreditzReport: state.applications.kreditzReport,
    accountInfos: state.users.accountInfos,
    creditApplications: state.applications.creditApplications,
    reviewingCreditApplications: state.applications.reviewingCreditApplications,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createKreditzReview: (applicationId) => {
      dispatch(applicationActions.create_kreditz_review(applicationId));
    },

    createKreditzReviewCredApp: (applicationId) => {
      dispatch(
        applicationActions.create_kreditz_review_credit_app(applicationId),
      );
    },

    getKreditzReport: (autoReviewId) => {
      dispatch(applicationActions.get_kreditz_report(autoReviewId));
    },

    getApplications: () => {
      dispatch(applicationActions.get_applications());
    },

    moveToReview: (id) => {
      dispatch(applicationActions.transfer_to_review(id));
    },

    autoReview: (id) => {
      dispatch(applicationActions.auto_review(id));
    },

    changeApplicationListPage: (page) => {
      dispatch(applicationActions.change_application_list_page(page));
    },

    changeApplicationListFilter: (type, key, value) => {
      dispatch(applicationActions.change_application_list_filter(key, value));
    },

    approveApplication: (applicationId, offerId) => {
      dispatch(applicationActions.approve_application(applicationId, offerId));
    },

    rejectApplication: (applicationId) => {
      dispatch(applicationActions.reject_application(applicationId));
    },

    setRiskBasedOffer: (applicationId, accountId, data) => {
      var postData = {
        ApplicationId: applicationId,
        AccountId: accountId,
        ...data,
      };

      dispatch(applicationActions.set_risk_offer(postData));
    },

    setNominalBasedOffer: (applicationId, accountId, data) => {
      var postData = {
        ApplicationId: applicationId,
        AccountId: accountId,
        ...data,
      };

      dispatch(applicationActions.set_nominal_offer(postData));
    },

    getRowAdditionalData: (accountId, identity, bankAccountId, Id) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
      dispatch(get_row_additional_data_bisnode(accountId, Id));
    },

    getRowAdditionalDataPersonal: (
      accountId,
      identity,
      bankAccountId,
      Id,
      loanId,
    ) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
      dispatch(get_row_additional_data_bisnode(accountId, Id));
      if (loanId != null)
        dispatch(creditSettlementActions.get_loan_details(loanId));
    },

    swapApplications: () => {
      dispatch(applicationActions.swap_data());
    },

    getAccountInfoForId: (accountId) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
    },

    rebuildPendingApplications: () => {
      dispatch(applicationActions.rebuild_pending_applications());
    },

    // Credit application actions
    getCreditApplications: () => {
      dispatch(applicationActions.get_credit_applications());
    },

    getCreditApplicationsForAccount: (borrowerId, notReviewed = true) => {
      dispatch(
        applicationActions.get_credit_applications(
          borrowerId,
          null,
          notReviewed,
          null,
        ),
      );
    },
    getOnHoldCreditApplications: () => {
      dispatch(applicationActions.get_credit_applications(null, true));
    },
    rejectCreditApplication: (appId) => {
      dispatch(applicationActions.approve_reject_credit_offers(appId, 0));
    },
    approveCreditOffer: (offerId) => {
      dispatch(applicationActions.approve_credit_offer(offerId));
    },
    approveRejectCreditOffers: (appId, maxApproveAmount) => {
      dispatch(
        applicationActions.approve_reject_credit_offers(
          appId,
          maxApproveAmount,
        ),
      );
    },
    approveRejectCreditOffersFromBorrowerPage: (
      borrowerId,
      appId,
      maxApproveAmount,
    ) => {
      dispatch(
        applicationActions.approve_reject_credit_offers(
          appId,
          maxApproveAmount,
          borrowerId,
        ),
      );
    },
    rejectCreditOffer: (offerId) => {
      dispatch(applicationActions.reject_credit_offer(offerId));
    },
    putOnHold: (appId) => {
      dispatch(applicationActions.put_application_on_hold(appId, true));
    },
    removeFromOnHold: (appId) => {
      dispatch(applicationActions.put_application_on_hold(appId, false));
    },
    createCreditsafeReport: (appId, borrowerId) => {
      dispatch(applicationActions.create_creditsafe_report(appId, borrowerId));
    },
    expire: (appId) => {
      dispatch(applicationActions.expire_application(appId));
    },
  };
}

export const applicationConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
